import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  id: "bill-split-container",
  class: "container"
}
const _hoisted_2 = { class: "d-flex flex-row flex-wrap justify-content-between mb-3" }
const _hoisted_3 = { class: "third-screen pr-4" }
const _hoisted_4 = ["value", "onChange", "name"]
const _hoisted_5 = { class: "third-screen px-2" }
const _hoisted_6 = ["onUpdate:modelValue", "name"]
const _hoisted_7 = { class: "third-screen pl-4 d-flex flex-column flex-wrap justify-content-between" }
const _hoisted_8 = ["onUpdate:modelValue"]
const _hoisted_9 = { class: "form-label" }
const _hoisted_10 = { class: "d-flex flex-row flex-wrap justify-content-between" }
const _hoisted_11 = { class: "half-screen pr-3" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "half-screen pl-3" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "mr-3" }
const _hoisted_16 = { class: "mr-3" }
const _hoisted_17 = { key: 2 }
const _hoisted_18 = ["href"]
const _hoisted_19 = { class: "mr-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[20] || (_cache[20] = _createElementVNode("h1", null, "Bill Split Calculator", -1)),
    _cache[21] || (_cache[21] = _createElementVNode("p", null, " This app helps split the cost for meals. Enter the total cost of the meal after tax and tip, and the paying parties, and then continue following instructions to assign items to different people. It is capable of assigning any number of items to any one person and also of even splitting an item between any number of people. ", -1)),
    _cache[22] || (_cache[22] = _createElementVNode("p", null, " This is not yet capable of dealing with multiple paying parties or splitting an item unevenly (but reach out if this would be desired functionality and I can add it) ", -1)),
    _cache[23] || (_cache[23] = _createElementVNode("p", null, " Note: This page shall ideally soon be improved. This was done in the course of an evening, but shall soon be glorious when I decide to touch it up some other fine evening. ", -1)),
    _cache[24] || (_cache[24] = _createElementVNode("h2", null, "The Calculator", -1)),
    (_ctx.page === 'introInfo')
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitIntroInfo && _ctx.submitIntroInfo(...args)), ["prevent"]))
        }, [
          _cache[9] || (_cache[9] = _createElementVNode("label", { class: "form-label" }, "Total cost (including tax and tip)", -1)),
          _withDirectives(_createElementVNode("input", {
            required: "",
            type: "number",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.total) = $event)),
            step: "0.01",
            placeholder: "XX.YY",
            name: "total",
            class: "form-control"
          }, null, 512), [
            [_vModelText, _ctx.total]
          ]),
          _cache[10] || (_cache[10] = _createElementVNode("label", { class: "form-label" }, "Who are the paying parties", -1)),
          _withDirectives(_createElementVNode("input", {
            required: "",
            type: "text",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.names) = $event)),
            placeholder: "Mary, Steve, ...",
            name: "names",
            class: "form-control"
          }, null, 512), [
            [_vModelText, _ctx.names]
          ]),
          _cache[11] || (_cache[11] = _createElementVNode("button", {
            type: "submit",
            class: "btn btn-primary mt-3"
          }, "Submit", -1))
        ], 32))
      : _createCommentVNode("", true),
    (_ctx.page === 'items')
      ? (_openBlock(), _createElementBlock("form", {
          key: 1,
          onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitItems && _ctx.submitItems(...args)), ["prevent"])),
          class: "mb-3"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.id,
              class: "mb-4"
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _cache[12] || (_cache[12] = _createElementVNode("label", { class: "form-label" }, "Item name (optional)", -1)),
                  _createElementVNode("input", {
                    type: "text",
                    value: item.name,
                    onChange: event => item.name = event.target.value,
                    name: 'name' + item.id,
                    class: "form-control item-input"
                  }, null, 40, _hoisted_4)
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _cache[13] || (_cache[13] = _createElementVNode("label", { class: "form-label" }, "Item cost", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    step: "0.01",
                    "onUpdate:modelValue": ($event: any) => ((item.cost) = $event),
                    name: 'cost' + item.id,
                    class: "form-control item-input"
                  }, null, 8, _hoisted_6), [
                    [_vModelText, item.cost]
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _cache[15] || (_cache[15] = _createElementVNode("label", null, "Who ate it (check multiple to split)", -1)),
                  _createElementVNode("div", null, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.selectAll && _ctx.selectAll(...args))),
                      class: "mr-1"
                    }, null, 32),
                    _cache[14] || (_cache[14] = _createElementVNode("label", { class: "form-label" }, "Check all", -1))
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.namesList, (name) => {
                    return (_openBlock(), _createElementBlock("div", { key: name }, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": ($event: any) => ((item.owners[name]) = $event),
                        class: "mr-1"
                      }, null, 8, _hoisted_8), [
                        [_vModelCheckbox, item.owners[name]]
                      ]),
                      _createElementVNode("label", _hoisted_9, _toDisplayString(name), 1)
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("button", {
                    onClick: _withModifiers(($event: any) => (_ctx.removeItem(item)), ["prevent"]),
                    class: "btn btn-light",
                    style: {"width":"100%"}
                  }, "Remove " + _toDisplayString(item.name || 'Item'), 9, _hoisted_12)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("button", {
                    onClick: _withModifiers(($event: any) => (_ctx.duplicateItem(item)), ["prevent"]),
                    class: "btn btn-light",
                    style: {"width":"100%"}
                  }, "Duplicate " + _toDisplayString(item.name || 'Item'), 9, _hoisted_14)
                ])
              ]),
              _cache[16] || (_cache[16] = _createElementVNode("hr", null, null, -1))
            ]))
          }), 128)),
          _createElementVNode("span", _hoisted_15, [
            _createElementVNode("button", {
              class: "btn btn-secondary",
              onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.goBack('introInfo')), ["prevent"]))
            }, "Go Back")
          ]),
          _createElementVNode("span", _hoisted_16, [
            _createElementVNode("button", {
              onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addItem && _ctx.addItem(...args)), ["prevent"])),
              class: "btn btn-secondary"
            }, "Add Item")
          ]),
          _cache[17] || (_cache[17] = _createElementVNode("button", {
            type: "submit",
            class: "btn btn-primary"
          }, "Submit Items", -1))
        ], 32))
      : _createCommentVNode("", true),
    (_ctx.page === 'summary')
      ? (_openBlock(), _createElementBlock("form", _hoisted_17, [
          _cache[18] || (_cache[18] = _createElementVNode("b", null, "Everyone owes the following", -1)),
          _cache[19] || (_cache[19] = _createTextVNode(" (items are listed to make sure you inputted correctly; it will have a different sum than the output): ", -1)),
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.people, (person) => {
              return (_openBlock(), _createElementBlock("li", {
                key: person.name
              }, [
                _createElementVNode("b", null, _toDisplayString(person.name) + " owes " + _toDisplayString(person.trueDebt), 1),
                _createElementVNode("a", {
                  href: _ctx.venmoLink(person),
                  target: "_blank",
                  rel: "noreferrer noopener",
                  class: "ml-1"
                }, "(Request on Venmo)", 8, _hoisted_18),
                _createTextVNode(" [" + _toDisplayString(_ctx.describeItems(person.items)) + "] ", 1)
              ]))
            }), 128))
          ]),
          _createElementVNode("span", _hoisted_19, [
            _createElementVNode("button", {
              class: "btn btn-secondary",
              onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.goBack('items')), ["prevent"]))
            }, "Go Back")
          ]),
          _createElementVNode("button", {
            type: "submit",
            class: "btn btn-primary",
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args)))
          }, "Reset")
        ]))
      : _createCommentVNode("", true)
  ]))
}